import React, { FC, useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import RankingsIndexPage from '@buyside/components/presentation/RankingsIndexPage/rankingsIndexPage';

import { rankingsUrl } from '@buyside/util/urlHelper';

const RankingsIndexPageRoot: FC = () => {
  useEffect(() => {
    const el = document.getElementById('mainReactApp');
    el?.setAttribute('data-no-padding', 'true');
    return (): void => el?.removeAttribute('data-no-padding');
  }, []);

  return (
    <ErrorBoundary pageName="the rankings page">
      <Router basename={rankingsUrl()}>
        <Routes>
          <Route path="/" element={<Navigate to="/general" />} />
          <Route path="/:category" element={<RankingsIndexPage />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default RankingsIndexPageRoot;
